<p>
  day-item-details works! {{data$ | async}}
</p>
